import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from "src/environments/environment";
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of, switchMap } from 'rxjs';
import { ENCRYPTED_DATA } from 'src/app/secure-data/encrypted-data';

@Injectable({
	providedIn: 'root',
})



export class CryptoService {
	// private jsonUrl = 'assets/encrypted-data.json';
	private jsonUrl = 'src/assets/encrypted-data.json';
	decryptData: any;
	iv: any;
	secretKey: any;
	ekyciv: any;
	ekycSecretKey: any;
	datafetch: boolean = false;

	constructor(private http: HttpClient) { }

	decryptUserData(code: string) {

		
		// return this.http.get('./assets/encrypted-data.json').pipe(
		return of(ENCRYPTED_DATA).pipe(	
			catchError((error) => {
				console.error('Caught error:', error);
				throw new Error('Failed to fetch encrypted data');
			}),
			switchMap((response: any) => {
				// Extract the IV and secret key from the response
				this.iv = response.iv;
				this.secretKey = response.secretKey;
				this.ekyciv = response.ekycIv;
				this.ekycSecretKey = response.ekycSecretKey;

				// Decrypt the data
				const configuration = {
					keySize: 256 / 32,  // Ensure key size is correct (256 / 32 = 8)
					iv: CryptoJS.enc.Utf8.parse(this.iv),
					mode: CryptoJS.mode.CBC,
				};

				let bytes = CryptoJS.AES.decrypt(code, CryptoJS.enc.Utf8.parse(this.secretKey), configuration);
				const userData = bytes.toString(CryptoJS.enc.Utf8);
				

				if (userData) {
					return of(userData);  // Return the decrypted data as an observable
				} else {
					throw new Error('Decryption failed');
				}
			})
		);
	}

	decryptBankData(code: string) {
		// return this.http.get('./assets/encrypted-data.json').pipe(
		return of(ENCRYPTED_DATA).pipe(	
			catchError((error) => {
				console.error('Caught error:', error);
				throw new Error('Failed to fetch encrypted data');
			}),
			switchMap((response: any) => {
				this.iv = response.iv;
				this.secretKey = response.secretKey;
				this.ekyciv = response.ekycIv;
				this.ekycSecretKey = response.ekycSecretKey;

				// Now, perform the decryption
				let bytes = CryptoJS.AES.decrypt(code, CryptoJS.enc.Utf8.parse(this.ekycSecretKey), {
					keySize: 256 / 32,  // Ensure key size is correct (256 / 32 = 8)
					iv: CryptoJS.enc.Utf8.parse(this.ekyciv),
					mode: CryptoJS.mode.CBC,
				});
				let bankData = bytes.toString(CryptoJS.enc.Utf8);
				// console.log('Bank Data:', bankData);  // Log the actual decrypted bank data

				if (bankData) {
					return of(bankData);  // Return the decrypted data as an observable
				} else {
					throw new Error('Decryption failed');
				}
			})
		);
	}
}


export function decryptClientDetails(encryptedData: string) {
	const key = CryptoJS.enc.Utf8.parse(ENCRYPTED_DATA.clientDecryptKey);
	const iv = CryptoJS.enc.Utf8.parse('');

	const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
		iv: iv,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.Pkcs7,
	});

	return decrypted.toString(CryptoJS.enc.Utf8);
}

export function encryptClientDetails(plainText: string) {
	const key = CryptoJS.enc.Utf8.parse(ENCRYPTED_DATA.secretKey);
	const iv = CryptoJS.enc.Utf8.parse('');

	const encrypted = CryptoJS.AES.encrypt(plainText, key, {
		iv: iv,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.Pkcs7,
	});

	return encrypted.toString();
}

export function encryptPledgeData(rawStr: string) {
	// let wordArray = CryptoJS.enc.Utf8.parse(rawStr);
	// let encryptBase64 = CryptoJS.enc.Base64.stringify(wordArray);

	let key = CryptoJS.enc.Hex.parse("0123456789abcdef0123456789abcdef");
	let iv = CryptoJS.enc.Hex.parse("abcdef9876543210abcdef9876543210");

	let encryptBase64 = CryptoJS.AES.encrypt(rawStr, key, { iv: iv, padding: CryptoJS.pad.ZeroPadding }).toString();
	return encryptBase64;
}

export function decryptPledgeData(encryptedStr: string) {
    // Use the same key and IV as encryption
    let key = CryptoJS.enc.Hex.parse("0123456789abcdef0123456789abcdef");
    let iv = CryptoJS.enc.Hex.parse("abcdef9876543210abcdef9876543210");

    // Decrypt
    let decrypted = CryptoJS.AES.decrypt(encryptedStr, key, { iv: iv, padding: CryptoJS.pad.ZeroPadding });

    // Convert from WordArray to UTF-8 string
    let decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);

    return decryptedStr;
}